"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KilowattPerKelvin = exports.KilowattPerCelsius = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var power_1 = require("./power");
var temperature_1 = require("./temperature");
// Heat Capacity Rate
exports.KilowattPerCelsius = UnitDivide.powerByTemperature("KilowattPerCelsius", power_1.KiloWatt, temperature_1.Celsius);
exports.KilowattPerKelvin = UnitDivide.powerByTemperature("KilowattPerKelvin", power_1.KiloWatt, uom_1.BaseUnits.Kelvin);
//# sourceMappingURL=heat-capacity-rate.js.map